'use client'

import { navigateUrl } from "@/utils/client-request"
import { formatImageURL } from "@/utils/util"
import { getInitials } from "@/utils/avatar"
import { usePathname } from "next/navigation"

export default function BrandCard({ brand }: { brand: any, index?: number }) {
  const pathname = usePathname()

  return (
    <a href={navigateUrl(`/product?brand=${brand.id}`, pathname)} className="group block focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-foreground">
      <div className="aspect-square bg-muted grid place-items-center overflow-hidden">
        {brand?.thumbnail ? (
          <img src={formatImageURL(brand.thumbnail)} alt="" loading="lazy" className="max-w-[60%] max-h-[60%] object-contain transition-opacity duration-300 group-hover:opacity-80" />
        ) : (
          <span aria-hidden className="text-3xl tracking-[0.08em] text-muted-foreground transition-colors duration-300 group-hover:text-foreground">{getInitials(brand?.name)}</span>
        )}
      </div>
      <div className="pt-3">
        <h2 className="text-[13px] sm:text-sm text-foreground line-clamp-1">
          <span className="pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none">{brand.name}</span>
        </h2>
        <div className="mt-1 text-xs text-muted-foreground tabular-nums">{brand.productCount || 0} бүтээгдэхүүн</div>
      </div>
    </a>
  )
}
